import { Component, Inject, Injector, TemplateRef } from "@angular/core";
import { BaseComponent } from "../base-component/base.component";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationCallerCallBack } from "../../bloc/confiramtion-modal-bloc";
import { ConfirmationPopupService } from "../../services/confirmation-popup.service";

@Component({
    standalone: true,
    selector: 'app-base-confirmation-component',
    template: ``,
})
export class BaseConfirmationComponent extends BaseComponent {

    constructor(@Inject(String) protected override translationArr: string[] = [], protected override injector: Injector = null, @Inject(Boolean) public override getThemeColors?: boolean) {
        super(translationArr, injector, getThemeColors);
    }

    protected onOpenConfirmation<T>(
        dialog: MatDialog,
        confirmationComponent: TemplateRef<any>,
        caller: ConfirmationCallerCallBack<T>,
        afterCloseCallBack: () => void,
        title?: string,
        body?: string
    ) {
        this.injector.get(ConfirmationPopupService)
        .onOpenConfirmation(dialog, confirmationComponent, caller, title, body)
        .subscribe((res) => {
            if (res && res['confirmation']) {
                afterCloseCallBack();
            }
        });
    }
}